import { Module } from 'wrapper6'

const $ = jQuery

export default class UserLogin extends Module {
  ready (app) {
    if (document.querySelector('.woocommerce-form-login-toggle')) {
      const LOGIN_BTN = document.querySelector('.woocommerce-form-login-toggle .showlogin')
      const CLOSE_BTN = document.querySelector('.woocommerce-login-close')

      LOGIN_BTN.addEventListener('click', () => {
        document.querySelector('.woocommerce-login-wrapper').classList.add('show')
      })

      CLOSE_BTN.addEventListener('click', () => {
        LOGIN_BTN.click()
        document.querySelector('.woocommerce-login-wrapper').classList.remove('show')
      })
    }
  }
}
